import { PublicKey } from "@solana/web3.js";
import { makeDSTProgram } from "./makeDSTProgram.js";

export function setOperatorFee({
  newOperatorFee,
  dst,
  operator,
}: {
  dst: PublicKey;
  operator: PublicKey;
  newOperatorFee: number;
}) {
  const program = makeDSTProgram();
  const result = program.methods
    .setOperatorFee(newOperatorFee)
    .accountsPartial({
      operator,
      dst,
    });

  return result;
}
